<template>
  <div>
    <div class="popup-content d-flex flex-column justify-content-center align-items-stretch">
      <template v-for="(code, idx) in value">
        <div  v-if="code && code.value" :key="code.value" :class="`mb-3 ${idx ? 'mt-3' : ''}`">
          <div class="text-center">
            <code-title :value="code.value" class="mb-3"/>
          </div>

          <div class="w-100 d-flex align-items-stretch justify-content-center">
            <div class="row">
              <template v-for="workflow in workflowDetails">
                <div v-if="workflow && workflow.type"
                     :key="workflow.type"
                     :class="`col col-${Math.floor(12 / Object.keys(workflowDetails).length)} d-flex flex-column align-item-center justify-content-start`">
                  <label
                      class="d-flex flex-column align-items-center"
                      :for="`code_${code.value}_${workflow.type}`">
                    <img :src="workflow.image" alt="" class="image-wf">
                    <span v-text="workflow.title"  class="d-block h6 mt-2 text-center"/>
                    <span v-html="workflow.description" class="d-block text-center"/>

                    <span class="d-block text-center">
                      <input
                        type="radio"
                        :name="`code_${code.value}`"
                        :id="`code_${code.value}_${workflow.type}`"
                        class="workflow-radio"
                        v-model="model[idx]"
                        :value="workflow.type"/>
                        <span/>
                    </span>
                  </label>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="popup-actions pt-3 pb-1 d-flex justify-content-end align-items-center">
      <button
        v-text="cancel"
        class="btn btn-outline-primary mr-3"
        @click.prevent="$emit('cancel')"
      />
      <button
        v-text="next"
        class="btn btn-primary"
        @click.prevent="saveCodes"
        :disabled="!allSet"
      />
    </div>
  </div>
</template>

<script>
import {cloneDeep} from "lodash";
import Code from "./code.vue";

export default {
  components: {
    CodeTitle: Code,
  },
  props: {
    value: {required: true, type: Array}, // [{value: 'XXXX', type: 'NOT_SPECIFIED'}]
    workflowDetails: {type: Object, required: true},
    cancel: {type: String, required: false, default: 'Cancel'},
    next: {type: String, required: false, default: 'Next'},
  },

  data() {
    return {
      model: [],
    };
  },

  computed: {
    model: {
      get() {
        return this.value.map(code => code.type);
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },

    allSet() {
      return this.model.length === this.value.length;
    }
  },

  methods: {
    saveCodes() {
      const result = cloneDeep(this.value)
          .map((code,idx) => ({ ...code, tag: this.model[idx] }));

      this.$emit('save', result);
    }
  }
}
</script>
